const ROLE = {
    cofounder: "co-founder",
    vendor: "vendor",
};
export default ROLE;